import {NotificationType} from "./NotificationType";

export class EmployeeNotificationConfiguration{

  employeeId: string;
  onReceivingVacationRequest = NotificationType.NONE;
  onReceivingBankUsageRequest = NotificationType.NONE;
  onReceivingApplyOnOpenShift = NotificationType.NONE;
  onReceivingExchangeShiftRequest = NotificationType.NONE;
  onReceivingAvailabilitiesRequest = NotificationType.NONE;
  onReceivingUnAvailabilityRequest = NotificationType.NONE;


  _createSpecialElement(propertyName: string, data: any) {
    if ('onReceivingVacationRequest' === propertyName) {
      this.onReceivingVacationRequest = NotificationType.retrieveFromCode(data);
      return true;
    }
    if ('onReceivingBankUsageRequest' === propertyName) {
      this.onReceivingBankUsageRequest = NotificationType.retrieveFromCode(data);
      return true;
    }
    if ('onReceivingApplyOnOpenShift' === propertyName) {
      this.onReceivingApplyOnOpenShift = NotificationType.retrieveFromCode(data);
      return true;
    }
    if ('onReceivingExchangeShiftRequest' === propertyName) {
      this.onReceivingExchangeShiftRequest = NotificationType.retrieveFromCode(data);
      return true;
    }
    if ('onReceivingAvailabilitiesRequest' === propertyName) {
      this.onReceivingAvailabilitiesRequest = NotificationType.retrieveFromCode(data);
      return true;
    }
    if ('onReceivingUnAvailabilityRequest' === propertyName) {
      this.onReceivingUnAvailabilityRequest = NotificationType.retrieveFromCode(data);
      return true;
    }


    return false;
  }

}
